import type { MessageActionInvocationStatus } from '@atlassian/conversation-assistant-service-api/types/message-actions';
import { StoreActionLoggableName } from '@atlassian/conversation-assistant-store/controllers/chat/types';

import { createSafeAction, type SafeAction } from './createSafeAction';
import { getAgentMessageById } from './getAgentMessageById';
import type { ChatStoreAction } from './types';

type UpdateActionInvocationStatusArgs = {
	conversationId: string;
	messageId: string;
	invocationId: string;
	status: MessageActionInvocationStatus;
};

export const updateActionInvocationStatus: SafeAction<[UpdateActionInvocationStatusArgs]> =
	createSafeAction(
		StoreActionLoggableName.updateActionInvocationStatus,
		({
			conversationId,
			messageId,
			invocationId,
			status,
		}: UpdateActionInvocationStatusArgs): ChatStoreAction =>
			async ({ getState }, { getMessages, setMessages }) => {
				const currentConversation = getState().conversations[conversationId];
				if (!currentConversation) {
					return;
				}

				const messages = getMessages(conversationId);
				const agentMessage = getAgentMessageById(messages, messageId);

				if (!agentMessage.result) {
					return;
				}

				const updatedMessages = [...messages];

				updatedMessages[agentMessage.index] = {
					...agentMessage.result,
					invokedActions: {
						...agentMessage.result.invokedActions,
						[invocationId]: status,
					},
				};

				setMessages(conversationId, updatedMessages);
			},
	);
